/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {

document.addEventListener('theme:variant:change', function(evt) {
  

  const vID = evt.detail.variant.id;

  let ele = document.getElementsByClassName('availBox');
        for (let index = 0; index < ele.length; index++) {
            ele[index].style.display = "none";
        }
  document.getElementById(vID + "-Avail").style.display = "block";
  
});
  /**
document.addEventListener('theme:cart:added', function(){
insuranceCalc();
});
document.addEventListener("theme:cart:loaded", function(){
  fetch(window.Shopify.routes.root + 'cart.js')
  .then(response => response.json())
  .then(cart => console.log(cart.attributes));
document.querySelector('[name="attributes[insurance]"]').addEventListener("change", function(event) {
insuranceCalc();
    });
  });
  function insuranceSet(updates, attributes){
    console.log(updates);
    console.log(attributes);
            fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ updates: updates, attributes: attributes, sections:'cart-drawer' })
        })
        .then(response => {
          return response.json();
        })
        .catch((error) => {
          console.error('Error:', error);
        });
  }
  function insuranceCalc(){
  fetch(window.Shopify.routes.root + 'products/package-protection.js')
  .then(response => response.json())
  .then(insurProduct => {
  var reCalc = false;
  var insurVar = 0;
  var reqVar = 0;
  var reqPrice = 0;
  var insurTotal = 0;
  var exemptInCart = 0;
  var insurPercent = 0.0275;

  fetch(window.Shopify.routes.root + 'cart.js')
  .then(response => response.json())
  .then(cart => {
    for(item of cart.items){
      if(item.handle == "package-protection"){
        insurTotal = item.original_line_price;
        insurVar = item.variant_id;
        reqVar = item.variant_id;
        reqPrice = item.original_price;
      }
      else if(item.gift_card){
        exemptInCart = exemptInCart + item.original_line_price;
      }
    }
    var calcTotal = Math.round((cart.total_price - exemptInCart - insurTotal)*insurPercent);
    var attributes = {};
    var updates = {};
    if(calcTotal == 0){
      //no cart contents require insurance, hide the div entirely
      document.getElementById("insuranceDiv").style.display="none";
      attributes = {
          "insurance": "false",
          "decline-insurance": "not-declined"
        }
    }
    if(!document.querySelector('[name="attributes[insurance]"]').checked){
      //customer has declined insurance
      console.log("in declined");
      calcTotal = 0;
      attributes = {
          "insurance": "false",
          "decline-insurance": "declined"
        }
      insurTotal = 10000;
    }
    if(calcTotal == 0 && insurTotal > 0){
      console.log("in remove");
      //then there is insurance in the cart that shouldn't be, remove it
        updates = {};
      updates[insurVar] = 0;
      console.log(updates);
      console.log(attributes);
insuranceSet(updates, attributes);
    }
    else{
      //then the cart is eligible for insurance, check to see if right amount is applied
      for(v of insurProduct.variants){
        if(v.price < calcTotal){
          //do nothing, need to keep going to a higher variant
        }
        else{
          if(insurVar != v.id){
            reCalc = true;
            reqVar = v.id;
            reqPrice = v.price;
          }
          break;
        }
      }
      if(reCalc){
        //then current insurance amount in cart is not correct
        if(insurVar == 0)
        {
          updates = {};
      updates[reqVar] = 1;
        attributes = {
          "insurance": "true",
          "decline-insurance": "not-declined"
        }
      console.log(updates);
      console.log(attributes);
      insuranceSet(updates, attributes);
        }
        else{
          //insurance is currently in the cart, but not the correct amount, remove and add
          updates = {};
      updates[reqVar] = 1;
      updates[insurVar] = 0;
        attributes = {
          "insurance": "true",
          "decline-insurance": "not-declined"
        }
      console.log(updates);
      console.log(attributes);
      insuranceSet(updates, attributes);
        }
      }
    }
  })
    });
  }*/
})();
